import { useNavigate } from 'react-router-dom';

import { ArrowBack } from '@mui/icons-material';
import { IconButton } from '@mui/material';

export default function BackButton() {
  const navigate = useNavigate();

  return (
    <IconButton
      onClick={() => {
        navigate(-1);
      }}
    >
      <ArrowBack />
    </IconButton>
  );
}
